export const getNotificationTypeLabel = (type, t) => {
  switch (type) {
    case "sorting_campaign":
      return t("Sorting campaign");
    case "filling_level":
      return t("Filling level");
    case "characterization":
      return t("Characterization");
    case "qualicheck":
      return t("mobile_settings_notify_wqc");
    case "sorting_error":
      return t("Sorting errors");
    case "collection":
      return t("Collection");
    case "packmat":
      return t("Packmat");
    default:
      return t("Notifications");
  }
};

export const shouldShowNotificationDescription = (
  type,
  description,
  typeLabel,
) =>
  Boolean(description?.trim()) &&
  description.trim() !== typeLabel.trim() &&
  !["characterization", "qualicheck"].includes(type);
